/* tslint:disable */
/* eslint-disable */
/**
 * HCL Commerce Services - Account and Contract
 * These services provide APIs to manage accounts and contracts.  a contract is an agreement that represents the terms and conditions that apply to a transaction. An account is a relationship between the merchant and the financial institution that processes transactions for that merchant.
 *
 * The version of the OpenAPI document: 9.1.6
 * 
 * (C) Copyright HCL Technologies Limited 2021
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../../../../../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../../../../../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../../../../../base';
// @ts-ignore
import { FlowFlow } from '../../../../../com/hcl/commerce/typescript/axios';
/**
 * FlowApi - axios parameter creator
 * @export
 */
export const FlowApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Gets the flow info by flow ID.
         * @summary Get flow information by ID
         * @param {string} storeId The store identifier.
         * @param {string} flowId The flow ID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        flowFindByFlowId: async (storeId: string, flowId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('flowFindByFlowId', 'storeId', storeId)
            // verify required parameter 'flowId' is not null or undefined
            assertParamExists('flowFindByFlowId', 'flowId', flowId)
            const localVarPath = `/store/{storeId}/flow/{flowId}`
                .replace(`{${"storeId"}}`, String(storeId))
                .replace(`{${"flowId"}}`, String(flowId));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FlowApi - functional programming interface
 * @export
 */
export const FlowApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FlowApiAxiosParamCreator(configuration)
    return {
        /**
         * Gets the flow info by flow ID.
         * @summary Get flow information by ID
         * @param {string} storeId The store identifier.
         * @param {string} flowId The flow ID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async flowFindByFlowId(storeId: string, flowId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FlowFlow>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.flowFindByFlowId(storeId, flowId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * FlowApi - factory interface
 * @export
 */
export const FlowApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FlowApiFp(configuration)
    return {
        /**
         * Gets the flow info by flow ID.
         * @summary Get flow information by ID
         * @param {string} storeId The store identifier.
         * @param {string} flowId The flow ID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        flowFindByFlowId(storeId: string, flowId: string, options?: any): AxiosPromise<FlowFlow> {
            return localVarFp.flowFindByFlowId(storeId, flowId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FlowApi - object-oriented interface
 * @export
 * @class FlowApi
 * @extends {BaseAPI}
 */
export class FlowApi extends BaseAPI {
    /**
     * Gets the flow info by flow ID.
     * @summary Get flow information by ID
     * @param {string} storeId The store identifier.
     * @param {string} flowId The flow ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FlowApi
     */
    public flowFindByFlowId(storeId: string, flowId: string, options?: any) {
        return FlowApiFp(this.configuration).flowFindByFlowId(storeId, flowId, options).then((request) => request(this.axios, this.basePath));
    }
}
